import { FormSignatureCertificateModel } from "./FormSignatureCertificateModel";
import * as DateFNS from "date-fns";

export class ParsedFormSignatureCertificateModel
{
	private cert: FormSignatureCertificateModel;
	public constructor(cert: FormSignatureCertificateModel)
	{
		this.cert = cert;
		this.Subject = new Map<string, string>();
		cert.Subject.forEach((val) => this.Subject.set(val.Name, val.Value));
		this.SerialNumber = cert.SerialNumber;
		this.ValidFromDate = DateFNS.parseISO(cert.ValidFromDate);
		this.ValidToDate = DateFNS.parseISO(cert.ValidToDate);
		this.Issuer = new Map<string, string>();
		cert.Issuer.forEach((val) => this.Issuer.set(val.Name, val.Value));
	}
	public SerialNumber: string;
	public ValidFromDate: Date;
	public ValidToDate: Date;
	public Subject: Map<string, string>;
	public Issuer: Map<string, string>;
}
